module.exports = __webpack_public_path__ + "img/correctImg.c7ff2927.png";